module.exports = __webpack_public_path__ + "img/diagnostico@2x.84fa88a4.png";